
let wasm;

const heap = new Array(32).fill(undefined);

heap.push(undefined, null, true, false);

function getObject(idx) { return heap[idx]; }

let heap_next = heap.length;

function dropObject(idx) {
    if (idx < 36) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

const cachedTextDecoder = new TextDecoder('utf-8', { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

let cachedUint8Memory0 = new Uint8Array();

function getUint8Memory0() {
    if (cachedUint8Memory0.byteLength === 0) {
        cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

let WASM_VECTOR_LEN = 0;

const cachedTextEncoder = new TextEncoder('utf-8');

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length);
        getUint8Memory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len);

    const mem = getUint8Memory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3);
        const view = getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

let cachedInt32Memory0 = new Int32Array();

function getInt32Memory0() {
    if (cachedInt32Memory0.byteLength === 0) {
        cachedInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachedInt32Memory0;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

function _assertClass(instance, klass) {
    if (!(instance instanceof klass)) {
        throw new Error(`expected instance of ${klass.name}`);
    }
    return instance.ptr;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let stack_pointer = 32;

function addBorrowedObject(obj) {
    if (stack_pointer == 1) throw new Error('out of js stack');
    heap[--stack_pointer] = obj;
    return stack_pointer;
}

function getArrayU8FromWasm0(ptr, len) {
    return getUint8Memory0().subarray(ptr / 1, ptr / 1 + len);
}
/**
*/
export const MoveKind = Object.freeze({ Normal:0,"0":"Normal",TwoUp:2,"2":"TwoUp",EnPassant:3,"3":"EnPassant",CastleShort:4,"4":"CastleShort",CastleLong:5,"5":"CastleLong", });
/**
*/
export const Color = Object.freeze({ White:0,"0":"White",Black:1,"1":"Black", });
/**
*/
export const PieceKind = Object.freeze({ None:0,"0":"None",Pawn:1,"1":"Pawn",Knight:2,"2":"Knight",Bishop:3,"3":"Bishop",Rook:4,"4":"Rook",Queen:5,"5":"Queen",King:6,"6":"King", });
/**
*/
export class Board {

    static __wrap(ptr) {
        const obj = Object.create(Board.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_board_free(ptr);
    }
    /**
    * @returns {Board}
    */
    static initial() {
        const ret = wasm.board_initial();
        return Board.__wrap(ret);
    }
    /**
    * @returns {Board}
    */
    static empty() {
        const ret = wasm.board_empty();
        return Board.__wrap(ret);
    }
    /**
    * @param {string} fen
    * @returns {Board}
    */
    static from_fen(fen) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(fen, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.board_from_fen(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return Board.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {Coords} coords
    * @returns {Piece | undefined}
    */
    at(coords) {
        _assertClass(coords, Coords);
        var ptr0 = coords.ptr;
        coords.ptr = 0;
        const ret = wasm.board_at(this.ptr, ptr0);
        return ret === 0 ? undefined : Piece.__wrap(ret);
    }
    /**
    * @param {Coords} coords
    * @param {Piece} piece
    * @returns {Piece | undefined}
    */
    put(coords, piece) {
        _assertClass(coords, Coords);
        var ptr0 = coords.ptr;
        coords.ptr = 0;
        _assertClass(piece, Piece);
        var ptr1 = piece.ptr;
        piece.ptr = 0;
        const ret = wasm.board_put(this.ptr, ptr0, ptr1);
        return ret === 0 ? undefined : Piece.__wrap(ret);
    }
    /**
    * @returns {Uint8Array}
    */
    cells() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.board_cells(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v0 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1);
            return v0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}
/**
*/
export class Coords {

    static __wrap(ptr) {
        const obj = Object.create(Coords.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_coords_free(ptr);
    }
    /**
    * @returns {number}
    */
    get x() {
        const ret = wasm.__wbg_get_coords_x(this.ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set x(arg0) {
        wasm.__wbg_set_coords_x(this.ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get y() {
        const ret = wasm.__wbg_get_coords_y(this.ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set y(arg0) {
        wasm.__wbg_set_coords_y(this.ptr, arg0);
    }
    /**
    * @param {number} x
    * @param {number} y
    */
    constructor(x, y) {
        const ret = wasm.coords_new(x, y);
        return Coords.__wrap(ret);
    }
    /**
    * @returns {boolean}
    */
    in_bounds() {
        const ret = wasm.coords_in_bounds(this.ptr);
        return ret !== 0;
    }
}
/**
*/
export class Engine {

    static __wrap(ptr) {
        const obj = Object.create(Engine.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_engine_free(ptr);
    }
    /**
    * @returns {Engine}
    */
    static initial() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.engine_initial(retptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return Engine.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} arg0
    * @returns {Engine}
    */
    static from_pgn(arg0) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.engine_from_pgn(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return Engine.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} fen
    * @returns {Engine}
    */
    static from_fen(fen) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(fen, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.engine_from_fen(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return Engine.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {any} value
    * @returns {boolean}
    */
    submit_move(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.engine_submit_move(retptr, this.ptr, addHeapObject(value));
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 !== 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Uint8Array}
    */
    cells() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.board_cells(retptr, this.ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v0 = getArrayU8FromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 1);
            return v0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {number}
    */
    color_to_move() {
        const ret = wasm.engine_color_to_move(this.ptr);
        return ret >>> 0;
    }
    /**
    * @returns {boolean}
    */
    is_in_check() {
        const ret = wasm.engine_is_in_check(this.ptr);
        return ret !== 0;
    }
    /**
    * @returns {any}
    */
    legal_moves() {
        const ret = wasm.engine_legal_moves(this.ptr);
        return takeObject(ret);
    }
}
/**
*/
export class LocatedPiece {

    static __wrap(ptr) {
        const obj = Object.create(LocatedPiece.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_locatedpiece_free(ptr);
    }
    /**
    * @returns {Piece}
    */
    get piece() {
        const ret = wasm.__wbg_get_locatedpiece_piece(this.ptr);
        return Piece.__wrap(ret);
    }
    /**
    * @param {Piece} arg0
    */
    set piece(arg0) {
        _assertClass(arg0, Piece);
        var ptr0 = arg0.ptr;
        arg0.ptr = 0;
        wasm.__wbg_set_locatedpiece_piece(this.ptr, ptr0);
    }
    /**
    * @returns {Coords}
    */
    get coords() {
        const ret = wasm.__wbg_get_locatedpiece_coords(this.ptr);
        return Coords.__wrap(ret);
    }
    /**
    * @param {Coords} arg0
    */
    set coords(arg0) {
        _assertClass(arg0, Coords);
        var ptr0 = arg0.ptr;
        arg0.ptr = 0;
        wasm.__wbg_set_locatedpiece_coords(this.ptr, ptr0);
    }
    /**
    * @param {Piece} piece
    * @param {Coords} coords
    * @returns {LocatedPiece}
    */
    static new(piece, coords) {
        _assertClass(piece, Piece);
        var ptr0 = piece.ptr;
        piece.ptr = 0;
        _assertClass(coords, Coords);
        var ptr1 = coords.ptr;
        coords.ptr = 0;
        const ret = wasm.locatedpiece_new(ptr0, ptr1);
        return LocatedPiece.__wrap(ret);
    }
}
/**
*/
export class Move {

    static __wrap(ptr) {
        const obj = Object.create(Move.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_move_free(ptr);
    }
    /**
    * @returns {number}
    */
    get kind() {
        const ret = wasm.__wbg_get_move_kind(this.ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} arg0
    */
    set kind(arg0) {
        wasm.__wbg_set_move_kind(this.ptr, arg0);
    }
    /**
    * @returns {Coords}
    */
    get from() {
        const ret = wasm.__wbg_get_locatedpiece_coords(this.ptr);
        return Coords.__wrap(ret);
    }
    /**
    * @param {Coords} arg0
    */
    set from(arg0) {
        _assertClass(arg0, Coords);
        var ptr0 = arg0.ptr;
        arg0.ptr = 0;
        wasm.__wbg_set_locatedpiece_coords(this.ptr, ptr0);
    }
    /**
    * @returns {Coords}
    */
    get to() {
        const ret = wasm.__wbg_get_move_to(this.ptr);
        return Coords.__wrap(ret);
    }
    /**
    * @param {Coords} arg0
    */
    set to(arg0) {
        _assertClass(arg0, Coords);
        var ptr0 = arg0.ptr;
        arg0.ptr = 0;
        wasm.__wbg_set_move_to(this.ptr, ptr0);
    }
    /**
    * @returns {Piece | undefined}
    */
    get capture() {
        const ret = wasm.__wbg_get_move_capture(this.ptr);
        return ret === 0 ? undefined : Piece.__wrap(ret);
    }
    /**
    * @param {Piece | undefined} arg0
    */
    set capture(arg0) {
        let ptr0 = 0;
        if (!isLikeNone(arg0)) {
            _assertClass(arg0, Piece);
            ptr0 = arg0.ptr;
            arg0.ptr = 0;
        }
        wasm.__wbg_set_move_capture(this.ptr, ptr0);
    }
    /**
    * @returns {Piece | undefined}
    */
    get promotion() {
        const ret = wasm.__wbg_get_move_promotion(this.ptr);
        return ret === 0 ? undefined : Piece.__wrap(ret);
    }
    /**
    * @param {Piece | undefined} arg0
    */
    set promotion(arg0) {
        let ptr0 = 0;
        if (!isLikeNone(arg0)) {
            _assertClass(arg0, Piece);
            ptr0 = arg0.ptr;
            arg0.ptr = 0;
        }
        wasm.__wbg_set_move_promotion(this.ptr, ptr0);
    }
    /**
    * @param {Coords} from
    * @param {Coords} to
    * @returns {Move}
    */
    static normal(from, to) {
        _assertClass(from, Coords);
        var ptr0 = from.ptr;
        from.ptr = 0;
        _assertClass(to, Coords);
        var ptr1 = to.ptr;
        to.ptr = 0;
        const ret = wasm.move_normal(ptr0, ptr1);
        return Move.__wrap(ret);
    }
    /**
    * @param {Coords} from
    * @param {Coords} to
    * @returns {Move}
    */
    static castle_short(from, to) {
        _assertClass(from, Coords);
        var ptr0 = from.ptr;
        from.ptr = 0;
        _assertClass(to, Coords);
        var ptr1 = to.ptr;
        to.ptr = 0;
        const ret = wasm.move_castle_short(ptr0, ptr1);
        return Move.__wrap(ret);
    }
    /**
    * @param {Coords} from
    * @param {Coords} to
    * @returns {Move}
    */
    static castle_long(from, to) {
        _assertClass(from, Coords);
        var ptr0 = from.ptr;
        from.ptr = 0;
        _assertClass(to, Coords);
        var ptr1 = to.ptr;
        to.ptr = 0;
        const ret = wasm.move_castle_long(ptr0, ptr1);
        return Move.__wrap(ret);
    }
    /**
    * @param {Coords} from
    * @param {Coords} to
    * @returns {Move}
    */
    static two_up(from, to) {
        _assertClass(from, Coords);
        var ptr0 = from.ptr;
        from.ptr = 0;
        _assertClass(to, Coords);
        var ptr1 = to.ptr;
        to.ptr = 0;
        const ret = wasm.move_two_up(ptr0, ptr1);
        return Move.__wrap(ret);
    }
    /**
    * @param {Coords} from
    * @param {Coords} to
    * @returns {Move}
    */
    static en_passant(from, to) {
        _assertClass(from, Coords);
        var ptr0 = from.ptr;
        from.ptr = 0;
        _assertClass(to, Coords);
        var ptr1 = to.ptr;
        to.ptr = 0;
        const ret = wasm.move_en_passant(ptr0, ptr1);
        return Move.__wrap(ret);
    }
    /**
    * @param {Piece} piece
    * @returns {Move}
    */
    with_capture(piece) {
        const ptr = this.__destroy_into_raw();
        _assertClass(piece, Piece);
        var ptr0 = piece.ptr;
        piece.ptr = 0;
        const ret = wasm.move_with_capture(ptr, ptr0);
        return Move.__wrap(ret);
    }
    /**
    * @param {Piece} piece
    * @returns {Move}
    */
    with_promotion(piece) {
        const ptr = this.__destroy_into_raw();
        _assertClass(piece, Piece);
        var ptr0 = piece.ptr;
        piece.ptr = 0;
        const ret = wasm.move_with_promotion(ptr, ptr0);
        return Move.__wrap(ret);
    }
    /**
    * @param {any} value
    * @returns {Move}
    */
    static from_value(value) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.move_from_value(retptr, addBorrowedObject(value));
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return Move.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            heap[stack_pointer++] = undefined;
        }
    }
}
/**
*/
export class Piece {

    static __wrap(ptr) {
        const obj = Object.create(Piece.prototype);
        obj.ptr = ptr;

        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.ptr;
        this.ptr = 0;

        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_piece_free(ptr);
    }
    /**
    * @returns {number}
    */
    get kind() {
        const ret = wasm.__wbg_get_piece_kind(this.ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} arg0
    */
    set kind(arg0) {
        wasm.__wbg_set_piece_kind(this.ptr, arg0);
    }
    /**
    * @returns {number}
    */
    get color() {
        const ret = wasm.__wbg_get_piece_color(this.ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} arg0
    */
    set color(arg0) {
        wasm.__wbg_set_piece_color(this.ptr, arg0);
    }
    /**
    * @param {number} kind
    * @param {number} color
    */
    constructor(kind, color) {
        const ret = wasm.piece_new(kind, color);
        return Piece.__wrap(ret);
    }
    /**
    * @returns {Piece}
    */
    static empty() {
        const ret = wasm.piece_empty();
        return Piece.__wrap(ret);
    }
    /**
    * @param {number} byte
    * @returns {Piece}
    */
    static from_encoded(byte) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.piece_from_encoded(retptr, byte);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return Piece.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {number}
    */
    encoded() {
        const ret = wasm.piece_encoded(this.ptr);
        return ret;
    }
    /**
    * @returns {boolean}
    */
    is_none() {
        const ret = wasm.piece_is_none(this.ptr);
        return ret !== 0;
    }
    /**
    * @returns {number}
    */
    score() {
        const ret = wasm.piece_score(this.ptr);
        return ret >>> 0;
    }
}

async function load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function getImports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = getStringFromWasm0(arg0, arg1);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_json_parse = function(arg0, arg1) {
        const ret = JSON.parse(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_json_serialize = function(arg0, arg1) {
        const obj = getObject(arg1);
        const ret = JSON.stringify(obj === undefined ? null : obj);
        const ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbindgen_debug_string = function(arg0, arg1) {
        const ret = debugString(getObject(arg1));
        const ptr0 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len0;
        getInt32Memory0()[arg0 / 4 + 0] = ptr0;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };

    return imports;
}

function initMemory(imports, maybe_memory) {

}

function finalizeInit(instance, module) {
    wasm = instance.exports;
    init.__wbindgen_wasm_module = module;
    cachedInt32Memory0 = new Int32Array();
    cachedUint8Memory0 = new Uint8Array();


    return wasm;
}

function initSync(module) {
    const imports = getImports();

    initMemory(imports);

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return finalizeInit(instance, module);
}

async function init(input) {
    if (typeof input === 'undefined') {
        input = new URL('index_bg.wasm', import.meta.url);
    }
    const imports = getImports();

    if (typeof input === 'string' || (typeof Request === 'function' && input instanceof Request) || (typeof URL === 'function' && input instanceof URL)) {
        input = fetch(input);
    }

    initMemory(imports);

    const { instance, module } = await load(await input, imports);

    return finalizeInit(instance, module);
}

export { initSync }
export default init;
